export const mutations = {
  addToUndoStack(state, operation) {
    state.undoStack.push(operation);
  },
  addToDoStack(state, operation) {
    state.doStack.push(operation);
  },
  clearUndoStack(state) {
    state.undoStack = [];
  },
  clearDoStack(state) {
    state.doStack = [];
  },
  popDoStack(state) {
    state.doStack.pop();
  },
  popUndoStack(state) {
    state.undoStack.pop();
  },
  updateCurrentOperationPromise(state, currentOperationPromise) {
    state.currentOperationPromise = currentOperationPromise;
  },
};
